var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.25 13.75V9.25H7.75V10.75H13.75V12.25H7.75V13.75H6.25ZM0.25 12.25V10.75H4.75V12.25H0.25ZM3.25 9.25V7.75H0.25V6.25H3.25V4.75H4.75V9.25H3.25ZM6.25 7.75V6.25H13.75V7.75H6.25ZM9.25 4.75V0.25H10.75V1.75H13.75V3.25H10.75V4.75H9.25ZM0.25 3.25V1.75H7.75V3.25H0.25Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.fc10f53b9bbe67d12bf6e8911d2c20d7.svg";
export { ForwardRef as ReactComponent };